// extracted by mini-css-extract-plugin
module.exports = {"message":"_2TRn4BV7 p2","list-title":"_2JYFekWA mb1","listTitle":"_2JYFekWA mb1","list":"_1FqlDexz","recap":"Ig7FZtcs mt1"};